export const AnswerFormats = {
    DATE: "DATE",
    DECIMAL: "DECIMAL",
    INTEGER: "INTEGER",
    MULTIPLE_PAIN_SCALE: "MULTIPLE_PAIN_SCALE",
    MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
    MULTIPLE_CHOICE_PAIN_AREAS: "MULTIPLE_CHOICE_PAIN_AREAS",
    OPTIONS: "OPTIONS",
    TIME: "TIME",
};
